import { Controller } from '@hotwired/stimulus'

const ESPERA = 2500

// «Compartir» en la cabecera de la comparativa de ETFs (`comparar.haml`). En el móvil abre el menú de compartir
// del teléfono (WhatsApp, correo…); en el resto, o si no lo hay, copia el enlace y lo dice en el propio botón y a
// quien usa lector de pantalla. La URL llega de la vista, sin la búsqueda ni el periodo del gráfico. Sin JS el
// botón no sale: la barra de direcciones ya hace lo mismo.
export default class extends Controller {
  static targets = ['boton', 'texto', 'aviso']
  static values = { url: String, titulo: String }

  connect () {
    this.textoInicial = this.textoTarget.textContent
    this.botonTarget.hidden = false
  }

  disconnect () {
    clearTimeout(this.temporizador)
  }

  async compartir () {
    if (this.conMenu()) {
      try {
        await navigator.share({ title: this.tituloValue, url: this.urlValue })
        return
      } catch (error) {
        // Cerrar el menú sin elegir nada no es un fallo.
        if (error.name === 'AbortError') return
      }
    }
    await this.copiar()
  }

  // El menú del sistema solo en pantallas táctiles: en el escritorio, copiar es lo que se espera.
  conMenu () {
    return typeof navigator.share === 'function' && window.matchMedia('(pointer: coarse)').matches
  }

  async copiar () {
    try {
      await navigator.clipboard.writeText(this.urlValue)
      this.avisa('Enlace copiado')
    } catch {
      this.avisa('No se ha podido copiar')
    }
  }

  avisa (mensaje) {
    this.textoTarget.textContent = mensaje
    this.avisoTarget.textContent = mensaje
    clearTimeout(this.temporizador)
    this.temporizador = setTimeout(() => {
      this.textoTarget.textContent = this.textoInicial
      this.avisoTarget.textContent = ''
    }, ESPERA)
  }
}
